import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApi from "../../../../shared/hooks/useApi";
import { PatientTaskInstanceId } from "../../../../shared/schema/schema";
import { TASKS_NEW_REGULAR_QUERY_KEY } from "./documentActions";

export function useUpdatePatientTaskInstanceNotes() {
  const { api } = useApi();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      taskInstanceId,
      notes,
    }: {
      taskInstanceId: PatientTaskInstanceId;
      notes: string | null;
    }) => {
      return api.put("./patient_task_instances/:patientTaskInstanceId/notes", {
        path: { patientTaskInstanceId: taskInstanceId },
        body: { notes },
      });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: [TASKS_NEW_REGULAR_QUERY_KEY] }),
  });
}
